{
  "GENERAL": {
    "CLOSE": "Zapri",
    "SHOWING_RESULTS": "Prikaz {firstIndex}-{lastIndex} od {totalCount} elementov",
    "PHONE_INPUT": {
      "PLACEHOLDER": "Iskanje",
      "EMPTY_STATE": "Ni rezultatov"
    }
  },
  "TAG_INPUT": {
    "MIN_TAGS_REQUIRED": "Zahtevano je vsaj {count}"
  }
}
